require('angular')
    .module('wowApp.common')
    .service('AtmLocalService', ['$rootScope', 'LocalStorageService', '$state', require('./atm-local-service')])
    .service('AtmService', ['$window', '$injector', 'AtmLocalService', '$state', 'AtmGlobalContextService', '$log', '$location', '$timeout', require('./atm-service')])
    .service('AtmGlobalContextService', ['$window', '$state', 'CurrentUserService', 'StorePickerService', 'SettingsService', '$rootScope', 'AnonymousUserIdService', require('./atm-global-context-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/index.js
 **/